import * as Sentry from '@sentry/react-router';
import { StrictMode, startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import { ProvidersTree } from './contexts/root-providers.js';
import { initLocale } from './intl/active-locale.js';

if (window.location.hostname !== 'localhost') {
  const { hostname } = window.location;
  const environment =
    hostname.endsWith('granular-energy.com') && !hostname.includes('staging') ? 'PRODUCTION' : 'STAGING';
  const region = hostname.includes('-us') ? 'us' : 'eu';
  let userId = localStorage.getItem('sentryUserId') || undefined;

  if (!userId && window.crypto) {
    userId = crypto.randomUUID();
    localStorage.setItem('sentryUserId', userId);
  }

  Sentry.init({
    dsn: 'https://7e113ecf1c859cb4df675c6718f3cfad@o4507570821201920.ingest.de.sentry.io/4507627642159184',
    environment: region == 'us' ? 'PRODUCTION-US' : environment, // Temporary use of a separate environment, until the US region is fully live
    initialScope: {
      tags: { region },
      user: { id: userId },
    },
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: [API_PATH],
    tracesSampleRate: 1.0,
  });
}

async function enableMSW() {
  if (import.meta.env.DEV && MSW_ENABLED === 'true') {
    const { worker } = await import('../testing/mock-api-service/browser.js');

    return worker.start({
      // disable unhandled request warnings
      onUnhandledRequest: () => {},
    });
  }

  return Promise.resolve();
}

// Block hydration on the active locale so non-default users never see the default locale flash
Promise.all([enableMSW(), initLocale()]).then(() => {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <ProvidersTree>
          <HydratedRouter />
        </ProvidersTree>
      </StrictMode>,
    );
  });
});
